import { jsxs, jsx } from "react/jsx-runtime";
import Icon from "../../graphics/Icon/Icon.js";
import { sharedHandler } from "../../../shared/sharedHandler/sharedHandler.js";
import Paragraph from "../../typography/Paragraph/Paragraph.js";
import { rem, Box } from "@mantine/core";
import { forwardRef } from "react";
import Link from "../Link/Link.js";
import { resolveColor } from "./TextLink.helpers.js";
import '../../../assets/TextLink.css';const root = "_root_1dfa6_2";
const text = "_text_1dfa6_95";
const rightIconWrapper = "_rightIconWrapper_1dfa6_118";
const LinkStyles = {
  root,
  text,
  rightIconWrapper
};
const _TextLink = forwardRef((props, ref) => {
  const {
    variant = "inline",
    icon,
    color,
    text: text2,
    className,
    iconPlacement = "left",
    iconColor,
    iconBackground,
    scale,
    href,
    target,
    mod,
    justify,
    style,
    selected,
    condensed,
    weight,
    ...rest
  } = props;
  let resolvedIcon = icon;
  let resolvedIconPlacement = iconPlacement;
  const resolvedIconColor = iconColor || color || "dark";
  const typecastColor = color || "dark";
  if (variant === "cta" || variant === "external") {
    resolvedIcon = "ArrowRight";
    resolvedIconPlacement = "right";
  }
  const styleVariables = {
    "--passed-justify": justify,
    "--passed-weight": weight,
    "--passed-color": resolveColor(typecastColor)
  };
  return /* @__PURE__ */ jsxs(
    Link,
    {
      ...rest,
      href,
      target,
      ref,
      className: `${LinkStyles.root} ${className}`,
      mod: { variant, selected, weight, ...mod },
      scale,
      style: { ...styleVariables, ...style },
      children: [
        icon && resolvedIconPlacement === "left" && /* @__PURE__ */ jsx(
          Icon,
          {
            scale,
            name: icon,
            color: resolvedIconColor,
            variant: iconBackground ? "filled" : "transparent",
            radius: "xl",
            size: variant === "inline" ? rem("20px") : rem("24px"),
            p: rem("6px")
          }
        ),
        /* @__PURE__ */ jsx(
          Paragraph,
          {
            scale,
            text: text2,
            variant: color || "link",
            className: LinkStyles.text,
            mod: { variant },
            inherit: true,
            condensed
          }
        ),
        resolvedIcon && resolvedIconPlacement === "right" && /* @__PURE__ */ jsx(Box, { className: LinkStyles.rightIconWrapper, component: "span", children: /* @__PURE__ */ jsx(
          Icon,
          {
            scale,
            name: resolvedIcon,
            color: resolvedIconColor,
            className: LinkStyles.rightIcon,
            size: rem("24px")
          }
        ) })
      ]
    }
  );
});
_TextLink.displayName = "TextLink";
const TextLink = sharedHandler(_TextLink);
TextLink.displayName = _TextLink.displayName;
export {
  LinkStyles as L,
  TextLink as default
};
